import {
  BubbleChart,
  ShoppingCart,
  Star,
  VolunteerActivism,
  People,
  Paid,
  Sell,
  Interests,
  DirectionsRun
} from "@mui/icons-material";

import { Variable } from "@/types";

export const demographicsCheck = (variables: Variable[]) => {;
  const demogs = variables.filter(x => x.tag_group === 'Demographics');
  return demogs.some((variable, idx) => demogs.findIndex(v => v.tag_category === variable.tag_category) !== idx);
}

export const getVariableIcon = (variable: Variable) => {
  switch (variable.tag_type) {
    case "Spend Merchants":
      return <ShoppingCart fontSize="small"/>
    case "Spend Categories":
      return <Sell fontSize="small" />
    case "Demographics":
      if (variable.tag_category === 'Income Band') {
        return <Paid fontSize="small" />
      } else {
      return <People fontSize="small" />
    }
    case "Interests":
      return <Interests fontSize="small" />
    case "Causes":
      return <VolunteerActivism fontSize="small" />
    case "Movement":
      return <DirectionsRun fontSize="small" />
    case "Mindsets":
      return <BubbleChart fontSize="small" />
    default:
      return <Star fontSize="small" />
  }
}

export const getTypeIcon = (tag_type: string) => {
  switch (tag_type) {
    case "Spend Merchants":
      return <ShoppingCart fontSize="small" />
    case "Spend Categories":
      return <ShoppingCart fontSize="small" />
    case "Demographics":
      return <People fontSize="small" />
    case "Interests":
      return <Interests fontSize="small" />
    case "Causes":
      return <VolunteerActivism fontSize="small" />
    case "Movement":
      return <DirectionsRun fontSize="small" />
    case "Mindsets":
      return <BubbleChart fontSize="small" />
    default:
      return <Star fontSize="small" />
  }
}
